"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _chunkOL2KRAIPjs = require('./chunk-OL2KRAIP.js');var _react = require('react'); var _react2 = _interopRequireDefault(_react);var _styled = require('@emotion/styled'); var _styled2 = _interopRequireDefault(_styled);var _jsxruntime = require('react/jsx-runtime');var c=_styled2.default.div`
  position: fixed;
  background: ${o=>o.$color};
  z-index: 999;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
`,p= exports.a =_react2.default.forwardRef((o,e)=>{let t=_chunkOL2KRAIPjs.b.call(void 0, ),{className:l,color:a=`${t.BASE_FILL}80`,children:s}=o;return _jsxruntime.jsx.call(void 0, c,{className:`${l||""} aquilla-overlay overlay`,$color:a,ref:e,children:s})}),y= exports.b =p;exports.a = p; exports.b = y;
